import { MenuProps, Menu as RACMenu } from "react-aria-components";
import { cn } from "../../cn";

const Menu = <T extends object>(props: MenuProps<T>) => (
  <RACMenu {...props} className={cn("outline-hidden", props.className)} />
);

Menu.displayName = "Menu";

export default Menu;
